import { Checkbox, CheckboxGroup } from '@globalmed/atlas-ui';
import { useState } from 'react';
import { TFormBuilderMultipleChoiceField } from '@/types';

type TProps = {
  field: TFormBuilderMultipleChoiceField;
};

/**
 * Preview component for multiple choice field in form builder
 * @param props - Component props
 * @param props.field - Multiple choice field data to preview
 * @returns Form builder multiple choice preview component
 */
export const FormBuilderPreviewMultipleChoice = ({ field }: TProps) => {
  const [values, setValues] = useState<string[]>([]);
  return (
    <CheckboxGroup
      label={field.label}
      checkedValues={values}
      onChangeValues={setValues}
      required={field.required}
    >
      {field.options.map(({ id, value }) => (
        <Checkbox key={id} size="sm" value={id} label={value} />
      ))}
    </CheckboxGroup>
  );
};
